export const AUTH_TOKEN = 'auth-token';
export const GUEST_TOKEN = 'guest-token';
export const LOCALE = 'locale';
export const COUNTRY_CODE = 'country_code';
export const PENDING_SEARCH_TERM = 'pending-search-term';
export const PERSISTED_ID = 'persisted-id';
export const GUEST_ID = 'cto_lwid';
export const SENTRY_DSN =
  'https://17c5da493186406f8f15ac1a2b91f80c@sentry.io/297951';
export const ROLLBAR_ACCESS_TOKEN = '4ceebf3364984c368e703cf2356fafd2';
export const FB_APP_ID = '1550564425258683';
export const FB_PAGE_ID = '294557780726895';
export const COMPLETE_PROFILE_POP_UP = '';
export const REGISTERED_COMPLETE_PROFILE = false;
// export const GOOGLE_APP_ID = "620483071827-eporef4ounmcjr51pm30vifis4vulvd4.apps.googleusercontent.com"
// export const GOOGLE_APP_ID = "620483071827-5flkbc98o50rce2ae13f989h3tuoqup6.apps.googleusercontent.com"
export const GOOGLE_APP_ID =
  '261485658549-a1ucl0cjddi9q61qrovqf2u2q5u2824k.apps.googleusercontent.com';



// WEBPACK FOOTER //
// ./app/config/constants.js